import { AppWindow } from '../../definitions/AppWindow';
import { getCwContext, getLocationHref } from '../js/windowProperties';

declare let window: AppWindow;
export const POLL_BATCH = 10;
export const POLL_INTERVAL = 200;

// tags that we want to omit from the data sent to FPTI, unless specifically provided
const OMIT_TAGS = ['erpg', 'page_error'];

export function filterErrorPage(data) {
  if (data) {
    const target = data.data || data;

    OMIT_TAGS.forEach((tag) => {
      target[tag] = null;
    });
  }
  return data;
}

export function addMetaTags(data) {
  if (data) {
    const target = data.data || data;
    const drawer = document.querySelector('.cw_navbar_drawer');
    target.cutils_version = getCwContext()?.appVersion || 'n/a';
    target.cutils_pageurl = getLocationHref()?.split('?')[0] || 'n/a';
    target.cutils_datasource = drawer?.getAttribute('data-source') || 'n/a';
    target.cutils_dataversion = drawer?.getAttribute('data-version') || 'n/a';
  }
  return data;
}

export function postProcessData(data) {
  filterErrorPage(data);
  addMetaTags(data);
  return data;
}

export function getProxyWithDirectApi() {
  return {
    recordImpression: (data, props) => {
      if (props) {
        window.PAYPAL?.analytics?.instance?.recordImpression(postProcessData(data), postProcessData(props));
      } else {
        window.PAYPAL?.analytics?.instance?.recordImpression(postProcessData(data));
      }
    },
    record: (data) => {
      window.PAYPAL?.analytics?.instance?.record(postProcessData(data));
    },
    recordClick: (data) => {
      window.PAYPAL?.analytics?.instance?.recordClick(postProcessData(data));
    },
    start: () => {},
  };
}

export function getProxyToEnqueueCalls(queue) {
  return {
    recordImpression: (...args) => {
      queue.push({ methodName: 'recordImpression', args });
    },
    record: (...args) => {
      queue.push({ methodName: 'record', args });
    },
    recordClick: (...args) => {
      queue.push({ methodName: 'recordClick', args });
    },
    queue,
    start: () => {},
  };
}

export function poll(proxy) {
  const api = window.PAYPAL?.analytics?.instance;
  if (api && !proxy.queue.length) {
    Object.assign(proxy, getProxyWithDirectApi());
    clearInterval(proxy.intervalId);
    proxy.intervalId = null;
  }
  if (api) {
    proxy.queue.splice(0, POLL_BATCH).forEach(({ methodName, args }) => {
      api[methodName](...args);
    });
  }
}

export function startPoll(proxy) {
  if (proxy.intervalId) {
    return;
  }
  proxy.intervalId = setInterval(() => poll(proxy), POLL_INTERVAL);
}

export default function fptiTrackingProxy(): { recordImpression; record; recordClick; start; queue? } {
  const api = window.PAYPAL?.analytics?.instance;
  if (api) {
    return getProxyWithDirectApi();
  }
  const queue = [];
  const proxy = getProxyToEnqueueCalls(queue);
  proxy.start = () => {
    startPoll(proxy);
  };
  return proxy;
}
